import * as utils from "../core/utils.js"
import * as icons from "../core/icons.js"
import { resolveAssetUrl } from "../core/utilsForAssetPaths.js";

const Logo = function({ translator, dom, getTheme, state }) {
  const template = `<a><span class="image"></span><span class="text"></span></a>`;
  
  const CLASS = "Logo";
  const theme = getTheme(CLASS) || {};
  const placeHolder = d3.select(dom);
  if(!placeHolder || placeHolder.empty()) return;   
  placeHolder.html(template);
  if(theme.style)
    Object.entries(theme.style).forEach( ([key, value]) => placeHolder.style(key, value) );

  const imageEl = placeHolder.select(".image");
  const textEl = placeHolder.select(".text");

  const { image, text, textHover, url, resetStateOnClick } = theme;
  if(image) 
    imageEl.html(icons[image] || `<img src="${resolveAssetUrl(image)}"/>`);
  if(text) {
    textEl.attr("data-text", text);
    translate();
  }
  if(resetStateOnClick)
    placeHolder.on("click", state.resetState );
  if(!resetStateOnClick && url) 
    placeHolder.select("a").attr("href", url);

  translate();
  state.dispatch.on("translate.logo", translate);

  function translate() {
    textEl.each(utils.translateNode(translator));
  }
};

export default Logo;
